import React from "react";

function ArrowRightIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 19 17"
    >
      <path
        fill="currentColor"
        d="M0 9.5h14.586l-5.293 5.292 1.414 1.414L18.414 8.5 10.707.792 9.293 2.206 14.586 7.5H0v2z"
      ></path>
    </svg>
  );
}

export default ArrowRightIcon;
